"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevourIQImportRestaurantToJSON = exports.DevourIQImportRestaurantFromJSONTyped = exports.DevourIQImportRestaurantFromJSON = void 0;
function DevourIQImportRestaurantFromJSON(json) {
    return DevourIQImportRestaurantFromJSONTyped(json, false);
}
exports.DevourIQImportRestaurantFromJSON = DevourIQImportRestaurantFromJSON;
function DevourIQImportRestaurantFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uberEatsUrl': json['uberEatsUrl'],
    };
}
exports.DevourIQImportRestaurantFromJSONTyped = DevourIQImportRestaurantFromJSONTyped;
function DevourIQImportRestaurantToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uberEatsUrl': value.uberEatsUrl,
    };
}
exports.DevourIQImportRestaurantToJSON = DevourIQImportRestaurantToJSON;
